export default __webpack_public_path__ + "static/media/profile-img.2ad6e5fb.png";